var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendingUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: " trending-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9925 6.963C20.9905 6.891 20.9695 6.823 20.9505 6.754C20.9355 6.696 20.9285 6.637 20.9035 6.584C20.8805 6.532 20.8415 6.49 20.8075 6.442C20.7655 6.381 20.7275 6.32 20.6735 6.27C20.6645 6.261 20.6605 6.249 20.6505 6.241C20.6145 6.21 20.5705 6.199 20.5315 6.174C20.4715 6.135 20.4125 6.095 20.3445 6.069C20.2775 6.045 20.2115 6.039 20.1425 6.029C20.0945 6.022 20.0515 6 20.0005 6H15.0005C14.4475 6 14.0005 6.448 14.0005 7C14.0005 7.552 14.4475 8 15.0005 8H17.8265L13.7905 12.708L9.5145 10.143C9.0915 9.887 8.5475 9.981 8.2315 10.36L3.2315 16.36C2.8785 16.784 2.9355 17.415 3.3595 17.768C3.5475 17.924 3.7735 18 3.9995 18C4.2865 18 4.5705 17.878 4.7685 17.64L9.2205 12.298L13.4855 14.858C13.9045 15.109 14.4425 15.021 14.7595 14.651L19.0005 9.703V12C19.0005 12.552 19.4475 13 20.0005 13C20.5535 13 21.0005 12.552 21.0005 12V7C21.0005 6.987 20.9935 6.976 20.9925 6.963Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingUp);
export default __webpack_public_path__ + "static/media/TrendingUp.caf362eca19fdad5135b2f55e7673443.svg";
export { ForwardRef as ReactComponent };